import React from "react";
import Layout from "../Shared/Layout";
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import AccordionList from "../Shared/AccordionList";
import {Trans} from "../utils/i18n";

const NiuRepairBoxImg = styled.img`
    width: 140px;
    height: 140px;
    margin: auto;
    object-fit: contain;
`;

const SpaceLeft = styled.div`
    margin-left: 45rem;
    @media (min-width: 100px) and (max-width: 1024px) {
        margin-left: 0rem;
        background: #fff;
        padding: 0px;
        width: 90%;
        height: auto;
        margin: auto;
        box-shadow: 2px 2px 8px 1px #ddd;
        position: relative;
        top: 94px;
    }
`;

const languageList = [
    {
        email: "Global-Service@niu.com",
        hours: "11:00 AM - 08:00 PM EST",
        phone: "+1(888) 241-0666",
        text: <Trans i18nKey="profile.english">English</Trans>,
        code: "en",
    },
    {
        email: "Global-Service@niu.com",
        hours: "11:00 AM - 08:00 PM CET",
        phone: "+33-0805-980-421",
        text: <Trans i18nKey="profile.french">French</Trans>,
        code: "fr",
    },
    {
        email: "Global-Service@niu.com",
        hours: "11:00 AM - 08:00 PM CET",
        phone: "+49 8005 8892 24",
        text: <Trans i18nKey="profile.german">German</Trans>,
        code: "de",
    },
    {
        email: "Global-Service@niu.com",
        hours: "11:00 AM - 08:00 PM CET",
        phone: "+34-800000006",
        text: <Trans i18nKey="profile.spanish">Spanish</Trans>,
        code: "es",
    },
];

export function NeedHelpAndLanguagesSection({languages, currentLanguage}) {
    const language = languages.find(
        (country) => country.code === currentLanguage
    );
    const languageData =
        languageList.find((country) => country.code === currentLanguage) ??
        languageList.find((country) => country.code === "en");

    return (
        <div className="w-full flex flex-col items-center mt-20">
            <h2 className={"text-center text-2xl font-bold mb-10 mt-8"}>
                <Trans i18nKey={"homeNiu.contactUs"}>Need help?</Trans>
            </h2>
            <div
                className="bg-white shadow-[0_0_12px_0_rgba(0,0,0,0.10)] rounded-lg px-8 pt-6 pb-8 flex flex-col w-full max-w-xl text-center mb-20">
                <p className="mb-4">
                    <h1 className="text-lg font-semibold m-0">
                        <Trans i18nKey={"homeNiu.callCenterFor"}>
                            NIU Call Center for
                        </Trans>{" "}
                        {language?.name}
                    </h1>
                </p>
                <p className="mb-4 mt-0">{languageData?.phone}</p>
                <p className="mb-4 mt-0">{languageData?.hours}</p>
                <p className="mb-4 mt-0">
                    <a
                        href={languageData?.email}
                        className="no-underline text-black hover:text-blue-500"
                    >
                        {languageData?.email}
                    </a>
                </p>
                <p className="mb-0 mt-0">
                    <a
                        href={
                            "https://chatting.page/hshkp4ayyxjw7uuhae23kqil5ngpvj7n"
                        }
                        className="inline-block no-underline bg-secondary hover:bg-secondary-700 text-white font-bold py-4 px-6 rounded"
                    >
                        <Trans i18nKey={"homeNiu.chatWithAgent"}>
                            Chat with a live agent
                        </Trans>
                    </a>
                </p>
            </div>

            <div className="flex flex-col md:flex-row gap-12 justify-center">
                {languageList?.map((language, index) => {
                    return (
                        <div className="" key={language.code}>
                            <h2 className="text-lg font-semibold">
                                {language.text}
                            </h2>
                            <p className="text-gray-700">{language.phone}</p>
                            <p className="text-gray-700">{language.hours}</p>
                            <a
                                href={`mailto:${language.email}`}
                                className="text-gray-700 no-underline"
                            >
                                {language.email}
                            </a>
                            <a
                                href={
                                    "https://chatting.page/hshkp4ayyxjw7uuhae23kqil5ngpvj7n"
                                }
                                className="block mt-4 text-secondary font-bold py-2 rounded outline-none focus:shadow-outline"
                            >
                                <Trans i18nKey={"homeNiu.chatWithAgent"}>
                                    Chat with a live agent
                                </Trans>
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default function HomeNIU({languages, currentLanguage, faqs}) {
    const { environment } = usePage().props;

    return (
        <div className={"-mt-12 bgcolor"}>
            <div
                className={`w-full bg-pattern  xs:bg-[url('/images/niu/mobile-bg.png')]  md:bg-[url('/images/niu/mobile-bg.png')] bg-[url('/images/niu/banner_home_widefg.png')] lg:bg-[url('/images/niu/banner_home_widefg.png')] bg-center bg-no-repeat bg-cover p-2  py-16 `}
            >
                <div className={`lg:mx-auto max-w-[2200px] relative`}>
                    <Container maxWidth="lg">
                        <SpaceLeft
                            className={`relative w-[calc(100%-45rem)] text-white flex flex-col items-center`}
                        >
                            <h1
                                className={
                                    "text-center text-black text-3xl font-bold mt-6 m-0"
                                }
                            >
                                <Trans i18nKey={"homeNiu.header"}>
                                    NIU Kick Scooter Repair Service
                                </Trans>
                            </h1>
                            <p
                                className={
                                    "text-center text-black text-xl font-medium mt-4 mb-0"
                                }
                            >
                                <Trans i18nKey={"homeNiu.description"}>
                                    NIU Kick Scooter Authorized Repair Service
                                </Trans>
                            </p>
                            <p
                                className={
                                    "text-center  mt-3  mb-9 lg:mb-0 lg:mt-12"
                                }
                            >
                                <InertiaLink
                                    className={
                                        "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                    }
                                    href={route("order")}
                                >
                                    <Trans
                                        i18nKey={"homeNiu.requestRepairButton"}
                                    >
                                        Request Repair
                                    </Trans>
                                </InertiaLink>
                            </p>
                            <p
                                className={
                                    "text-center  mt-3  mb-9 lg:mb-0 lg:mt-6"
                                }
                            >
                                <InertiaLink
                                    className={
                                        "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                    }
                                    href={route("partsshop.index")}
                                >
                                    <Trans i18nKey={'homeNiu.buyPartsButton'}>Buy Parts</Trans>
                                </InertiaLink>
                            </p>
                            <p
                                className={
                                    "text-center  mt-3  mb-9 lg:mb-0 lg:mt-12"
                                }
                            >
                                <InertiaLink
                                    className={
                                        "block font-bold text-secondary"
                                    }
                                    href={route("track.index")}
                                >
                                    <Trans
                                        i18nKey={"homeNiu.checkRepairStatus"}
                                    >
                                        Check Status
                                    </Trans>
                                </InertiaLink>
                            </p>
                        </SpaceLeft>
                    </Container>
                </div>
            </div>
            <Container maxWidth="lg">
                <div className={"max-w-xl mx-auto"}>
                    <h2 className={"text-center text-5xl font-bold mt-16 mb-0"}>
                        <Trans i18nKey={"homeNiu.repairOptions"}>
                            Repair Options
                        </Trans>
                    </h2>
                </div>
                <div className={"relative"}>
                    <div
                        className={
                            "mx-auto mt-20 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between niu-repair-box max-w-4xl"
                        }
                    >
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center box"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px]"
                                }
                            >
                                <NiuRepairBoxImg
                                    src={"/images/niu/selffix.png"}
                                    className={""}
                                />
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('selfrepair.guides.index')}
                                        className={
                                            "text-xl font-bold niutitle underline-offset-4 text-secondary"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "homeNiu.repairOptions.selfFix"
                                            }
                                        >
                                            Self Fix
                                        </Trans>
                                    </InertiaLink>
                                    <p
                                        className={
                                            "font-regular flex-1 niudesc mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "homeNiu.repairOptions.selfFix.description"
                                            }
                                        >
                                            Self repair, don't replace. Your device, our Earth.
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <NiuRepairBoxImg
                                    src={"/images/niu/mailin.png"}
                                    className={""}
                                />
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('order')}
                                        className={
                                            "text-xl font-bold niutitle underline-offset-4 text-secondary"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "homeNiu.repairOptions.mailIn"
                                            }
                                        >
                                            Mail In
                                        </Trans>
                                    </InertiaLink>
                                    <div
                                        className={
                                            "font-regular flex-1 niudesc mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "homeNiu.repairOptions.mailIn.description"
                                            }
                                        >
                                            Send your device for a faster repair
                                        </Trans>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <NiuRepairBoxImg
                                    src={"/images/niu/exchange.png"}
                                    className={""}
                                />
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                     <InertiaLink
                                        href={route('partsshop.index')}
                                        className={
                                            "text-xl font-bold niutitle underline-offset-4 text-secondary"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "homeNiu.buyPartsButton"
                                            }
                                        >
                                            Buy Parts
                                        </Trans>
                                    </InertiaLink>
                                    <p
                                        className={
                                            "font-regular flex-1 niudesc mt-4"
                                        }
                                    >
                                        <Trans
                                                i18nKey={
                                                    "homeNiu.repairOptions.buyParts.description"
                                                }
                                        >
                                            Buy Genuine NIU Parts
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {environment !== 'production' && (
                    <div
                        className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] overflow-hidden">
                        <iframe src="https://app.intellegam.com/iframe/chat?endpoint=%22https%3A%2F%2Fapi.intellegam.com%2Fb2x%2Fdemo%2Fniuscooter%2Fchat%22&subscriptionKey=6QzdwcSB4ux9l5eock%2BRJG1iqEqBodyIvmEk8qbxUERJg4NrKdTfWQgE2gkstwsojOckt1uIHQSj74caZss%3D" width="100%" height="600" frameBorder="0"></iframe>
                    </div>                    
                )}

                <div
                    className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                    {faqs.length > 0 && (
                        <>
                            <h2
                                className={
                                    "text-center text-2xl font-bold mb-0 mt-8"
                                }
                            >
                                <Trans i18nKey={"homeNiu.faq.title"}>
                                    FAQs & Troubleshooting Guides
                                </Trans>
                            </h2>
                            <p
                                className={
                                    "text-center text-md font-medium mt-4"
                                }
                            >
                                <Trans i18nKey={"homeNiu.faq.subtitle"}>
                                    All you need to know about our service offer
                                </Trans>
                            </p>
                            <div className="w-11/12">
                                <AccordionList items={faqs}/>
                            </div>
                        </>
                    )}
                    <p className={"text-center mt-3 mb-8 pt-8"}>
                        <InertiaLink
                            className={" block font-bold text-secondary"}
                            href={route("faq")}
                        >
                            <Trans i18nKey={"HomeNiu.checkAllResources"}>Check all the resources</Trans>
                        </InertiaLink>
                    </p>
                </div>

                {
                    <div
                        className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                        <h2
                            className={
                                "text-center text-2xl font-bold mb-0 mt-8"
                            }
                        >
                            <Trans i18nKey={"homeNiu.contactUs"}>
                                Need help?
                            </Trans>
                        </h2>
                        <p className={"text-center text-md font-medium mt-4"}>
                            <Trans i18nKey={"homeNiu.repairRequestDescription"}>
                                Let us know if you are facing any experiencing
                                any trouble with a repair request
                            </Trans>
                        </p>
                        <p className={"text-center mt-3 mb-8"}>
                            <InertiaLink
                                className={
                                    "no-underline block font-bold bg-secondary rounded-md text-white px-9 py-3  hover:bg-white hover:text-secondary shadow-lg shadow"
                                }
                                href={route("contact")}
                            >
                                <Trans i18nKey={"homeNiu.checkResource"}>
                                    Check resources
                                </Trans>
                            </InertiaLink>
                        </p>


                        <div className="flex flex-col md:flex-row gap-12 justify-center">
                            {languageList?.map((language, index) => {
                                return (
                                    <div className="" key={language.code}>
                                        <h2 className="text-lg font-semibold">
                                            {language.text}
                                        </h2>
                                        <p className="text-gray-700">{language.phone}</p>
                                        <p className="text-gray-700">{language.hours}</p>
                                        <a
                                            href={`mailto:${language.email}`}
                                            className="text-gray-700 no-underline"
                                        >
                                            {language.email}
                                        </a>
                                        <a
                                            href={
                                                "https://chatting.page/hshkp4ayyxjw7uuhae23kqil5ngpvj7n"
                                            }
                                            className="block mt-4 text-secondary font-bold py-2 rounded outline-none focus:shadow-outline"
                                        >
                                            <Trans i18nKey={"homeNiu.chatWithAgent"}>
                                                Chat with a live agent
                                            </Trans>
                                        </a>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                }
            </Container>
        </div>
    );
}

HomeNIU.layout = (page) => <Layout children={page}/>;
